var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcYellowCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_yellow-card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "33_Match-statistics",
    transform: "translate(-861, -731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(849, 539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-1, 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_yellow-card",
    transform: "translate(13, 172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2 C0,0.89544 0.897329114,0 2.00421941,0 L9.21940928,0 C10.3263196,0 11.2236287,0.89544 11.2236287,2 L11.2236287,15.2 C11.2236287,16.30458 10.3262996,17.2 9.21940928,17.2 L2.00421941,17.2 C0.897329114,17.2 0,16.30458 0,15.2 L0,2 Z",
    id: "Path",
    fill: "#E8D02D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81223629,15 C5.81223629,17.76142 8.05553903,20 10.8227848,20 C13.5900306,20 15.8333333,17.76142 15.8333333,15 C15.8333333,12.23858 13.5900306,10 10.8227848,10 C8.05553903,10 5.81223629,12.23858 5.81223629,15 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6244726,13 C11.6244726,12.55818 11.2655369,12.2 10.8227848,12.2 C10.3800327,12.2 10.021097,12.55818 10.021097,13 L10.021097,15 C10.021097,15.44182 10.3800327,15.8 10.8227848,15.8 C11.2655369,15.8 11.6244726,15.44182 11.6244726,15 L11.6244726,13 Z M10.8227848,17.8 C11.2655369,17.8 11.6244726,17.44182 11.6244726,17 C11.6244726,16.55818 11.2655369,16.2 10.8227848,16.2 C10.3800327,16.2 10.021097,16.55818 10.021097,17 C10.021097,17.44182 10.3800327,17.8 10.8227848,17.8 Z",
    id: "Shape",
    fill: "#E8D02D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYellowCard);
export default __webpack_public_path__ + "static/media/ic_yellow-card.51aeb6cbd2bee104804488fd2e7f34f7.svg";
export { ForwardRef as ReactComponent };